export default __webpack_public_path__ + "static/media/container3.1ad97f06.jpg";